module.exports = __webpack_public_path__ + "static/media/thumbnail-video-2@3x.46507a99.png";